import { format } from 'date-fns';
import store from 'index';

class MetadataOnSave {
    
    elements = {};

    constructor(elements = {}) {
        this.elements = { ...elements };
    }
    
    onCheckDateFromTo = (changedElements) => {
        let obj = "";
        
        if (changedElements.zeitraumjson) {
            try {
                obj = JSON.parse(changedElements.zeitraumjson);
            } catch (ex) {
                console.log("ERROR: JSON.parse(changedElements.zeitraumjson) " + changedElements.zeitraumjson);
            }
            
            if(!obj || !obj.from || !obj.from.y) {
                changedElements.zeitraumjson = "";
            }
        }
        
        return changedElements;
    }
}

export default MetadataOnSave;


